import { createFileRoute } from '@tanstack/react-router';
import { Permission } from '../../../features/common/permision';
import { ImageTranslationPage } from '../../../features/image/image-translation.page';

export const Route = createFileRoute('/_creator-center/images/translation')({
  staticData: { permissions: [Permission.图片翻译] },
  component: ImageTranslationPage,
});
